export default {
  LocaleSwitcher__LANGUAGE_EN: "English",
  LocaleSwitcher__LANGUAGE_ES: "Español",
};
